import { Box } from "@material-ui/core";
import React from "react";

export default function TabRender({ tabs, step, children, useBox = true, ...rest }) {

  const renderedTabs = React.useMemo(
    () =>
      tabs.map(({ component: { props, wrapper: Component }, value }, key) => {
        return step === value && <Component key={key} {...props} />;
      }),
    [tabs, step]
  );

  if (children)
    return tabs.map(({ value }) => {
      return step === value && children;
    });

  if (useBox) return <Box {...rest}>{renderedTabs}</Box>;

  return <>{renderedTabs}</>;
}
